<template>
  <div>
    <div v-if="!initialLoading">
      <div class="row">
        <div class="col-12 col-md-6 flexben-page-title d-flex flex-row align-items-center">
          <h1 class="mr-2">{{ requestData.benefit.name }}</h1>
          <span class="flx-type-badge mr-1">{{ $t("flexben.benefit.delivery_types."+requestData.metas.delivery_type.value) }}</span>
          <span v-if="requestData.for_demo" class="text-danger text-18 text-bold ml-2"> - Companie DEMO</span>
        </div>
        <div class="col-12 col-md-6 text-right">
          <button v-if="requestData.status==='new'" class="btn text-danger mb-1" @click="openRejectModal()">
            <font-awesome-icon icon="trash" class="mr-1"/>
            {{ $t("flexben.requests.btn.reject_request") }}
          </button>
          <button v-if="requestData.status==='await_voucher_upload'" class="btn text-danger mb-1" @click="openRejectModal()">
            <font-awesome-icon icon="trash" class="mr-1"/>
            {{ $t("flexben.requests.btn.reject_request") }}
          </button>
          <button v-if="requestData.status==='new'" class="btn btn-themed-o mr-1 mb-1" @click="markPending()">
            {{ $t("flexben.requests.btn.mark_pending") }}
          </button>
          <button :disabled="(requestData.status==='await_top_up' && requestData.benefit_voucher_id!=null) || (requestData.budget_type === 'card' && !cardPayment.id)"
                  class="btn btn-themed mb-1" @click="confirmPlaceOrder()">
            {{ $t("flexben.requests.btn.approve_request") }}
          </button>
        </div>
      </div>
      <div v-if="requestData.status==='await_top_up' && requestData.benefit_voucher_id!=null" class="row">
        <div class="col-12 text-danger text-center">
          {{ $t('flexben.requests.delivering_auto') }}
        </div>
      </div>
      <div v-if="errorPlacingOrder" class="my-3">
        <div class="alert alert-danger alert-dismissible mb-0 text-danger">
          <a type="button" class="close btn" data-dismiss="alert" @click="errorPlacingOrder = false; actionErrorMessage = null">&times;</a>
          {{ actionErrorMessage || $t("flexben.general.error_ups") }}
        </div>
      </div>
      <div class="container-bg-white mt-3">
        <div class="row p-3">
          <div class="col-12 d-flex flex-row">
            <h3 class="m-0 pl-0">{{ $t("flexben.requests.title_placed_at",{number:requestData.id}) }} {{
              moment(requestData.placed_at, 'DD/MM/YYYY HH:mm') }}</h3>
            <span class="beneficiary-request-status my-auto"
                  :class="'flx-'+requestData.status">{{ $t('flexben.requests.summary.status.' + requestData.status) }}
                    </span>
          </div>
          <div class="col-12 col-md-6 col-xl-4 form-group mb-0">
            <label class="col-form-label">{{ $t('flexben.requests.fields.value') }}</label>
            <div class="form-control disabled">{{ requestData.total_value }}</div>
          </div>

          <div v-if="requestData.metas.delivery_type.value==='general'"
               class="col-12 col-md-6 col-xl-4 form-group mb-0">
            <label class="col-form-label">{{ $t('flexben.requests.fields.card_request')}}</label>
            <div class="form-control disabled">{{ $t('flexben.general.'+((typeof
              requestData.metas.request_card!=='undefined')?'yes':'no')) }}
            </div>
          </div>
          <div v-if="requestData.metas.delivery_type.value==='card'"
               class="col-12 col-md-6 col-xl-4 form-group mb-0">
            <label class="col-form-label">{{ $t('flexben.requests.fields.card_series')}}</label>
            <div class="form-control disabled">{{ requestData.metas.card_series.value }}</div>
          </div>

          <div v-if="(requestData.metas.delivery_type.value==='digital_code' || requestData.metas.delivery_type.value==='digital_file')
           && options.has_voucher_stock"
               class="col-12 col-md-6 col-xl-4 form-group mb-0">
            <label class="col-form-label" for="consume_voucher_stock">{{
              $t('flexben.requests.fields.consume_voucher_stock')}}</label>

            <div class="d-flex flex-row pt-2">
              <span>{{ $t('flexben.general.no') }}</span>
              <b-form-checkbox id="consume_voucher_stock"
                               class="ml-3 mr-3"
                               switch
                               v-model="formData.consume_voucher_stock">
              </b-form-checkbox>
              <span>{{ $t('flexben.general.yes') }}</span>
            </div>
          </div>

          <div v-if="requestData.metas.delivery_type.value==='digital_code'"
               class="col-12 col-md-6 col-xl-4 form-group mb-0">
            <label class="col-form-label">{{ $t('flexben.requests.fields.voucher_code')}}</label>
            <input type="text" class="form-control" v-model="formData.voucher_code"
                   :disabled="formData.consume_voucher_stock"
                   :class="{'border-danger':(Object.keys(errorsBag).includes('voucher_code'))}"/>
          </div>

          <div v-if="requestData.metas.delivery_type.value==='digital_file'"
               class="col-12 col-md-6 col-xl-4 form-group mb-0">
            <label class="col-form-label">{{ $t('flexben.requests.fields.voucher_file')}}</label>
            <input type="file" class="form-control p-1" @change="processFile($event)"
                   :disabled="formData.consume_voucher_stock"
                   :class="{'border-danger':(Object.keys(errorsBag).includes('voucher_file'))}"/>
          </div>

          <div v-if="requestData.metas.delivery_type.value==='physical'"
               class="col-12 col-md-6 col-xl-8 form-group mb-0">
            <label class="col-form-label">{{ $t('flexben.requests.fields.physical_label')}}</label>
            <div class="py-2">
              {{ $t('flexben.requests.fields.physical_text')}}
            </div>
          </div>
        </div>
      </div>
      <RequestBenefitDynamicFields :requestData="requestData"/>
      <div v-if="showRecipientSection" class="container-bg-white mt-3">
        <div class="row p-3">
          <div class="col-12 mb-2">
            <h3 class="m-0 p-0 d-inline-block mr-2">{{ $t('flexben.requests.fields.recipient_section_title') }}</h3>
            <span class="flx-type-badge">{{ $t('flexben.requests.fields.purchased_for_someone_else_badge') }}</span>
          </div>
          <div class="col-12 mb-3">
            <div class="alert alert-info mb-0 py-2">
              {{ $t('flexben.requests.fields.purchased_for_someone_else_hint') }}
            </div>
          </div>
          <div class="col-12 col-md-6 col-xl-4 form-group mb-0">
            <label class="col-form-label">{{ $t('flexben.reports.world_class.fields.first_name') }}</label>
            <div class="form-control disabled">{{ requestData.recipient.first_name }}</div>
          </div>
          <div class="col-12 col-md-6 col-xl-4 form-group mb-0">
            <label class="col-form-label">{{ $t('flexben.reports.world_class.fields.last_name') }}</label>
            <div class="form-control disabled">{{ requestData.recipient.last_name }}</div>
          </div>
          <div class="col-12 col-md-6 col-xl-4 form-group mb-0">
            <label class="col-form-label">{{ $t('flexben.reports.world_class.fields.email') }}</label>
            <div class="form-control disabled">{{ requestData.recipient.email }}</div>
          </div>
          <div class="col-12 col-md-6 col-xl-4 form-group mb-0">
            <label class="col-form-label">{{ $t('flexben.reports.world_class.fields.phone') }}</label>
            <div class="form-control disabled">{{ requestData.recipient.phone_number }}</div>
          </div>
        </div>
      </div>
      <div class="container-bg-white mt-3">
        <div class="row p-3">
          <div class="col-12">
            <h3 class="m-0 pl-0">{{ $t("flexben.requests.payment_details") }}</h3>
          </div>
          <div v-if="requestData.budget_type === 'general'" class="col-12">
            <div class="form-control disabled text-success bg-light">
              {{ $t("flexben.requests.fields.payment_success") }}
            </div>
          </div>
          <template v-else>
            <div v-if="cardPayment.amount" class="col-12">
              <div class="form-control disabled text-success bg-light">
                {{ $t("flexben.requests.fields.payment_success") }}
              </div>
            </div>
            <div v-if="cardPayment.amount" class="col-12 col-md-6 form-group mb-0">
              <label class="col-form-label">{{ $t("flexben.requests.fields.payment_amount") }}</label>
              <div class="form-control disabled">{{ cardPayment.amount }}</div>
            </div>
            <div v-if="cardPayment.uuid" class="col-12 col-md-6 form-group mb-0">
              <label class="col-form-label">{{ $t("flexben.requests.fields.payment_uuid") }}</label>
              <div class="form-control disabled">{{ cardPayment.uuid }}</div>
            </div>
            <div v-if="cardPayment.created_at" class="col-12 col-md-6 form-group mb-0">
              <label class="col-form-label">{{ $t("flexben.requests.fields.payment_date") }}</label>
              <div class="form-control disabled">{{ moment(cardPayment.created_at, 'DD/MM/YYYY HH:mm') }}</div>
            </div>
            <div v-if="!cardPayment.amount && !cardPayment.uuid && !cardPayment.created_at" class="col-12">
              <div class="form-control disabled text-danger bg-light">
                {{ $t("flexben.requests.fields.no_payment") }}
              </div>
            </div>
          </template>
        </div>
      </div>
      <RequestEmployeeInfo :employee="requestData.company_employee"/>
      <div class="row mt-3">
        <div class="col-12 text-right">
          <button v-if="requestData.status==='new'" class="btn text-danger mb-1" @click="openRejectModal()">
            <font-awesome-icon icon="trash" class="mr-1"/>
            {{ $t("flexben.requests.btn.reject_request") }}
          </button>
          <button v-if="requestData.status==='await_voucher_upload'" class="btn text-danger mb-1" @click="openRejectModal()">
            <font-awesome-icon icon="trash" class="mr-1"/>
            {{ $t("flexben.requests.btn.reject_request") }}
          </button>
          <button v-if="requestData.status==='new'" class="btn btn-themed-o mr-1 mb-1" @click="markPending()">
            {{ $t("flexben.requests.btn.mark_pending") }}
          </button>
          <button :disabled="(requestData.status==='await_top_up' && requestData.benefit_voucher_id!=null) || (requestData.budget_type === 'card' && !cardPayment.id)"
                  class="btn btn-themed mb-1" @click="confirmPlaceOrder()">
            {{ $t("flexben.requests.btn.approve_request") }}
          </button>
        </div>
      </div>
    </div>
    <RejectModal :rejectData="rejectData"
                 :showDisableTopUps="false"
                 :extraMessage="shouldRefundCoinsOnReject ? $t('flexben.requests.modal.confirm_refund_coins_only_message') : null"
                 @confirmAction="rejectRequests()"
                 ref="reject-modal"/>
    <ConfirmMassPlaceOrderModal @placeOrder="placeOrder" ref="confirm_po_modal"/>
    <content-loader :loaderVisible="loading" :loaderError="loaderError"></content-loader>
  </div>
</template>

<script>
import httpFlexbenService from "@/http/http-flexben";
import RejectModal from "@/components/flexben/requests/modals/RejectModal";
import RequestBenefitDynamicFields
  from "@/components/flexben/requests/not_legislated/partials/RequestBenefitDynamicFields";
import RequestEmployeeInfo from "@/components/flexben/requests/not_legislated/partials/RequestEmployeeInfo";
import ConfirmMassPlaceOrderModal from "@/components/flexben/requests/modals/ConfirmMassPlaceOrderModal";
import {BFormCheckbox} from "bootstrap-vue";

export default {
  name: "VoucherRequestDetails",
  components: {
    ConfirmMassPlaceOrderModal,
    RejectModal,
    RequestBenefitDynamicFields,
    RequestEmployeeInfo,
    "b-form-checkbox": BFormCheckbox,
  },
  props: {
    detailsId: {
      required: true,
      type: Number
    }
  },
  data: function () {
    return {
      initialLoading: true,
      loading: false,
      loaderError: false,
      httpService: httpFlexbenService.requests,
      requestData: {},
      cardPayment: {},
      options: {
        has_voucher_stock: false
      },
      rejectData: {
        ids: [],
        reject_reason: ''
      },
      formData: {
        voucher_code: null,
        voucher_file: null,
        consume_voucher_stock: false,
      },
      errorPlacingOrder: false,
      actionErrorMessage: null,
      errorsBag: {},
      invalidOrderReason: null
    };
  },
  computed: {
    showRecipientSection() {
      return this.requestData.recipient && !this.requestData.personal_use;
    },
    shouldRefundCoinsOnReject() {
      var uuid = this.requestData.uuid
        || (this.requestData.order && this.requestData.order.uuid);
      var isAwaitVoucher = this.requestData.status === 'await_voucher_upload'
        || Number(this.requestData.status_new) === 14;
      var isCoins = Number(this.requestData.payment_method_enum) === 3
        || this.requestData.budget_type === 'coins';

      return isAwaitVoucher && !!uuid && isCoins;
    },
  },
  created() {
    this.rejectData.ids.push(this.detailsId);
    this._getRequestDetails();
  },
  methods: {
    goBack(withReRender = false) {
      this.$emit('hideDetails', withReRender)
    },
    openRejectModal() {
      this.$refs['reject-modal'].openModal();
    },
    showActionError(message) {
      this.loading = false;
      this.loaderError = false;
      this.actionErrorMessage = message || this.$t('flexben.general.error_ups');
      this.errorPlacingOrder = true;
      if (this.$bvToast) {
        this.$bvToast.toast(this.actionErrorMessage, {
          title: this.$t('flexben.requests.response.error'),
          solid: true,
          autoHideDelay: 5000,
          variant: 'danger',
        });
      }
    },
    rejectRequests() {
      this.$refs['reject-modal'].closeModal();
      this.errorPlacingOrder = false;
      this.actionErrorMessage = null;
      this.loading = true;

      // Coins eligible: backend reject redirects to refund (admin-only) and persists reject_reason.
      let payload = {...this.rejectData};

      this.httpService.rejectRequests(payload)
        .then(function () {
          this.loading = false;
          this.goBack(true);
        }.bind(this))
        .catch(function (error) {
          this.showActionError(
            (error.response && error.response.data && error.response.data.message)
            || this.$t('flexben.requests.modal.refund_error')
            || this.$t('flexben.general.error_ups')
          );
        }.bind(this));
    },
    placeOrder(action) {
      this.$refs['confirm_po_modal'].closeModal();
      this.errorPlacingOrder = false;
      this.actionErrorMessage = null;
      let payload = this._preparePayload(action);
      if (!this.errorPlacingOrder) {
        this.loading = true;
        if (action === 'order') {
          this.invalidOrderReason = null;
          this.httpService.orderVoucher(this.detailsId, payload)
            .then((response) => {
              this.loading = false;
              if (response.data.status === 'success') {
                this.goBack(true);
              } else {
                this.invalidOrderReason = this.$t('flexben.requests.errors.no_voucher_stocks')
              }
            })
            .catch((error) => {
              if (error.response.status >= 500 && error.response.status < 600) {
                this.loaderError = true;
              } else {
                this.errorPlacingOrder = true;
                this.loading = false;
              }
            });
        } else if (action === 'mark_pending') {
          this.httpService.voucherMarkPending(this.detailsId)
            .then(function (response) {
              this.loading = false;
              this.goBack(true);
            }.bind(this))
            .catch(function (error) {
              if (error.response.status >= 500 && error.response.status < 600) {
                this.loaderError = true;
              } else {
                this.errorPlacingOrder = true;
                this.loading = false;
              }
            }.bind(this));
        } else {
          this.loading = false;
        }
      } else {
        this.scrollToTop();
      }
    },
    processFile(event) {
      this.formData.voucher_file = event.target.files[0]
    },
    confirmPlaceOrder() {
      this.$refs['confirm_po_modal'].openModal('order');
    },
    markPending() {
      this.$refs['confirm_po_modal'].openModal('mark_pending');
    },
    _getRequestDetails() {
      this.loading = true;
      this.httpService.getRequestDetails(this.detailsId)
        .then((response) => {
          this.requestData = response.data.details;
          this.options = response.data.options;
          this.cardPayment = response.data.cardPayment || {};
          this.loading = false;
          this.initialLoading = false;
        })
        .catch((error) => {
          this.goBack();
        });
    },
    _preparePayload(action) {
      let formData = new FormData();
      if (action === 'order') {
        if (!this.formData.consume_voucher_stock) {
          if (this.requestData.metas.delivery_type.value === 'digital_code') {
            if (this.formData.voucher_code) {
              formData.append('voucher_value', this.formData.voucher_code);
            } else {
              this.errorsBag.voucher_code = 'required';
              this.errorPlacingOrder = true;
            }

          }
          if (this.requestData.metas.delivery_type.value === 'digital_file') {
            if (this.formData.voucher_file) {
              formData.append('voucher_value', this.formData.voucher_file);
            } else {
              this.errorsBag.voucher_file = 'required';
              this.errorPlacingOrder = true;
            }
          }
        }
        if (this.requestData.metas.delivery_type.value === 'digital_code' || this.requestData.metas.delivery_type.value === 'digital_file') {
          formData.append('consume_voucher_stock', this.formData.consume_voucher_stock ? 1 : 0);
        }
      }

      return formData;
    }
  }
}
</script>
